import { getDanaInvoice, InvoiceDetailsResult, RequestInvoiceApi } from "@dana/Services/DanaOrderRelatedService";
import { DanaInvoiceActions } from "@dana/Store/Data/OrderHistory/Reducers/GetDanaInvoiceReducer";
import { InvoiceDetailsResponse } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type RequestInvoice = {
    requestNumber?: string;
    requestType?: string;
} & HasOnSuccess<any> & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<RequestInvoice, RequestInvoiceApi, InvoiceDetailsResult, DispatchProp<DanaInvoiceActions>>;

export const SetLoadingOn: HandlerType = props => {
    props.dispatch?.({
        type: "DanaInvoice/IsLoading",
        isLoading: true,
    });
}

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getDanaInvoice({
        requestNumber: props.parameter.requestNumber,
        requestType: props.parameter.requestType,
    });
};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch?.({
            type: "DanaInvoice/PopulateResult",
            data: props.apiResult,
        } as any);
    }
}

export const chain = [SetLoadingOn, SendDataToApi, PopulateFacetResult];

const GetDanaInvoiceData = createHandlerChainRunner(chain, "GetDanaInvoiceData");
export default GetDanaInvoiceData;